export default [
  {
    title: 'ArcGIS Basemap',
    url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    maxZoom: 20,
    minZoom: 0,
    crossOrigin: 'Anonymous',
  },
  {
    title: 'Openstreet Road',
    url: 'http://tile.openstreetmap.org/{z}/{x}/{y}.png',
    maxZoom: 19,
    minZoom: 3,
    crossOrigin: 'Anonymous',
  },
];
